import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '仪表盘', icon: 'el-icon-s-data', permission: 'dashboard' }
      },
      {
        path: 'stores',
        name: 'Stores',
        component: () => import('@/views/stores/index.vue'),
        meta: { title: '门店列表', icon: 'el-icon-office-building', permission: 'stores' }
      },
      {
        path: 'stores/:id',
        name: 'StoreDetail',
        component: () => import('@/views/stores/detail.vue'),
        meta: { title: '门店详情', hidden: true, permission: 'stores' }
      },
      {
        path: 'employees',
        name: 'Employees',
        component: () => import('@/views/employees/index.vue'),
        meta: { title: '员工管理', icon: 'el-icon-user', permission: 'stores' }
      },
      {
        path: 'employees/salary',
        name: 'EmployeeSalary',
        component: () => import('@/views/employees/salary.vue'),
        meta: { title: '工资统计', icon: 'el-icon-money', permission: 'stores' }
      },
      {
        path: 'inventory/categories',
        name: 'InventoryCategories',
        component: () => import('@/views/inventory/categories.vue'),
        meta: { title: '分类管理', icon: 'el-icon-folder', permission: 'inventory' }
      },
      {
        path: 'inventory/products',
        name: 'InventoryProducts',
        component: () => import('@/views/inventory/products.vue'),
        meta: { title: '商品管理', icon: 'el-icon-goods', permission: 'inventory' }
      },
      {
        path: 'expense/categories',
        name: 'ExpenseCategories',
        component: () => import('@/views/finance/expense-categories.vue'),
        meta: { title: '支出分类管理', icon: 'el-icon-wallet', permission: 'expense' }
      },
      {
        path: 'expense/items',
        name: 'ExpenseItems',
        component: () => import('@/views/finance/expense-items.vue'),
        meta: { title: '支出项目管理', icon: 'el-icon-bank-card', permission: 'expense' }
      },
      {
        path: 'income/categories',
        name: 'IncomeCategories',
        component: () => import('@/views/finance/income-categories.vue'),
        meta: { title: '收入分类管理', icon: 'el-icon-coin', permission: 'income' }
      },
      {
        path: 'income/items',
        name: 'IncomeItems',
        component: () => import('@/views/finance/income-items.vue'),
        meta: { title: '收入项目管理', icon: 'el-icon-sell', permission: 'income' }
      },
      {
        path: 'audit/stock',
        name: 'StockAudit',
        component: () => import('@/views/audit/stock.vue'),
        meta: { title: '进货审核', icon: 'el-icon-truck', permission: 'audit' }
      },
      {
        path: 'audit/return',
        name: 'ReturnAudit',
        component: () => import('@/views/audit/return.vue'),
        meta: { title: '退货审核', icon: 'el-icon-rollback', permission: 'audit' }
      },
      {
        path: 'audit/manual-stock-in',
        name: 'ManualStockIn',
        component: () => import('@/views/audit/manual-stock-in.vue'),
        meta: { title: '手动入库记录', icon: 'el-icon-box', permission: 'audit' }
      },
      {
        path: 'messages',
        name: 'Messages',
        component: () => import('@/views/messages/index.vue'),
        meta: { title: '消息管理', icon: 'el-icon-message-solid', permission: 'messages' }
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('@/views/settings/index.vue'),
        meta: { title: '系统设置', icon: 'el-icon-setting', permission: 'settings' }
      }
    ]
  },
  {
    path: '*',
    redirect: '/dashboard'
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 权限 key 到默认路由的映射
const PERMISSION_ROUTE_MAP = {
  dashboard: '/dashboard',
  stores: '/stores',
  inventory: '/inventory/products',
  expense: '/expense/categories',
  income: '/income/categories',
  audit: '/audit/stock',
  messages: '/messages',
  settings: '/settings'
}

// 路由守卫
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - 九云元肌肤管理系统` : '九云元肌肤管理系统'
  const isLoggedIn = store.getters.isLoggedIn

  // 登录页直接放行
  if (to.path === '/login') {
    if (isLoggedIn) {
      // 已登录用户访问登录页 → 跳转到首页
      next({ path: '/', replace: true })
    } else {
      next()
    }
    return
  }

  // 未登录 → 跳转登录页
  if (!isLoggedIn) {
    next({ path: '/login', replace: true })
    return
  }

  // 检查路由权限
  const requiredPermission = to.meta.permission
  if (requiredPermission && !store.getters.hasPermission(requiredPermission)) {
    // 跳转到第一个有权限的页面
    const permissions = store.getters.permissions
    const firstAllowed = permissions.length > 0 ? permissions[0] : 'inventory'
    const redirectPath = PERMISSION_ROUTE_MAP[firstAllowed] || '/inventory/products'
    // 防止无限循环：如果权限数据异常导致重定向回同一路由，放行
    if (to.path === redirectPath) {
      next()
    } else {
      next({ path: redirectPath, replace: true })
    }
    return
  }

  next()
})

export default router
